import { render, staticRenderFns } from "./FactsheetRegulierLaden.vue?vue&type=template&id=a2db4bec&"
import script from "./FactsheetRegulierLaden.vue?vue&type=script&lang=js&"
export * from "./FactsheetRegulierLaden.vue?vue&type=script&lang=js&"
import style0 from "./FactsheetRegulierLaden.vue?vue&type=style&index=0&id=a2db4bec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports